import React, { useEffect, useRef, useState } from 'react'
import { SuccessModal, PaymentModal, ErrorModal } from '../../components/Modal'
import ViewRecoveryItemStyle from './ViewRecoveryItemStyle'
import { useLocation, useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import Layout from '../../components/Layout'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import api, { customFuncsApi } from '../../api'
import { AiOutlineSend } from 'react-icons/ai'
import { isEmpty } from 'lodash/lang'
import { roundCurrency } from '../../utils'
import moment from 'moment'
import CloseIcon from '../../assets/icons/close'
import ClipLoader from 'react-spinners/ClipLoader'
import 'moment-timezone'
import customMainApi from '../../api/index'
import FreezedPhonesSelectEmployeeModal from '../../components/Modal/FreezedPhonesSelectEmployeeModal'
import AddTask from '../../components/Modal/AddTask'
import ViewImage from '../../components/ViewImage/index'
import { Table, Tag, Input, Select, Tooltip } from 'antd'
import { formatNumberWithIntl } from '../../utils/formatNumber'
import { BG_COLOR } from '../../constants/colors'
const ViewRecoveryItem = () => {
	const { getMe, roleAccess } = useSelector((state) => state.main)

	const isChangeStatus = roleAccess.U_SalesViewChangeStatus === 'Y'
	const isChangeFreezed = roleAccess.U_SalesViewChangeFreezed === 'Y'
	const isShowAddPaymentBtn = roleAccess.U_SalesViewAddPaymentBTN === 'Y'
	const isShowEditCollector = roleAccess.U_SalesChangeCollector === 'Y'
	const isShowDeleteComment = roleAccess.U_SalesDeleteComment === 'Y'

	const navigate = useNavigate()
	const location = useLocation()

	const successRef = useRef()
	const errorRef = useRef()
	const paymentRef = useRef()
	const undiruvchiRef = useRef()
	const commentRef = useRef(null)
	const successModalRef = useRef()
	const addTask = useRef()

	const DocEntry = get(location, 'state.data.DocEntry', 0)
	const isTask = get(location, 'state.isTask', false)
	const InstlmntID = get(location, 'state.data.InstlmntID', 0)

	const [commentsLoading, setCommentsLoading] = useState(false)
	const [comment, setComment] = useState('')
	const [comments, setComments] = useState([])
	const [employeeID, setEmployeeID] = useState(null)
	const [dollarLoading, setDollarLoading] = useState(false)
	const [isCommitLoading, setIsCommitLoading] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [data, setData] = useState({})
	const [totalDebt, setTotalDebt] = useState(0)
	const [dollar, setDollar] = useState(1)
	const [executer, setExecuter] = useState([])
	const [executorLoading, setExecutorLoading] = useState(false)
	const [sumPay, setSumPay] = useState(0)
	const [payingSum, setPayingSum] = useState(0)
	const [tableData, setTableData] = useState([])
	const [u_Score, setU_Score] = useState('')
	const [userFields, setUserFields] = useState([])
	const [tableInvoicePayments, setTableInvoicePayments] = useState([])
	const [isFreezed, setIsFreezed] = useState('')
	const [task, setTask] = useState('')
	const [deadLine, setDeadLine] = useState('')
	const [statusTask, setStatusTask] = useState('')
	const [firstIsFreezed, setFirstIsFreezed] = useState('') //Backdan kevotgani bilan mijoz ozgartirganmi yoqmi tekshirish uchun ochildi
	const [freezedPhoneEmployee] = useState('') //Backdan kevotgani bilan mijoz ozgartirganmi yoqmi tekshirish uchun ochildi
	const [path, setPath] = useState([])
	const [invoiceDocLines, setInvoiceDocLines] = useState([])
	const [undiruvKim, setUndiruvKim] = useState('')
	const [itemsData, setItemsData] = useState([])
	const [invoiceLoading, setInvoiceLoading] = useState(false)
	const [isComment, setIsComment] = useState({
		loading: false,
		order: -1,
	})

	useEffect(() => {
		if (commentRef.current) {
			commentRef.current.scrollTop = commentRef.current.scrollHeight
		}
	}, [comments])

	useEffect(() => {
		getAllData()
		getComments()
		getInformationOfItem()
		userFieldsFn()
		getInvoicePayments()
		getAllGetterMoney()
		getUSD()
		getInvoice()
	}, [])

	const getInvoice = () => {
		setInvoiceLoading(true)
		api
			.get(`Invoices(${DocEntry})`)
			.then((res) => {
				const resData = JSON.parse(res.data)
				const docLines = get(resData, 'DocumentLines', [])
				getItems(docLines.map((v) => v.ItemCode))
				setInvoiceDocLines(docLines)
				setUndiruvKim(get(resData, 'U_Undrkim', ''))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setInvoiceLoading(false)
			})
	}

	const getItems = (codes) => {
		const filterQuery = `${codes.map((v, i) => `${i === 0 ? '' : ' or '}ItemCode eq '${v}'`).join('')}`
		api
			.get(
				`Items?$filter=${filterQuery}&$select=ItemCode,ItemName,U_Color,U_Condition,U_Group,U_Brand,U_Memory`,
			)
			.then((res) => {
				setItemsData(JSON.parse(res.data).value)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const getAllGetterMoney = () => {
		setExecutorLoading(true)
		api
			.get(
				`$crossjoin(EmployeesInfo, Departments)?$filter=(Departments/Name eq 'Undiruv' or Departments/Name eq 'Undiruvchi1' or Departments/Name eq 'Undiruvchi3' or Departments/Name eq 'Undiruvchi2') and EmployeesInfo/Department eq Departments/Code&$expand=EmployeesInfo($select=EmployeeID,LastName,FirstName),Departments($select=Name,Code)`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=90000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				// if (get(getMe, 'Department2.Name', '') === 'Undiruv') {
				// 	const data = resData.filter(
				// 		(v) => v.EmployeesInfo.EmployeeID === get(getMe, 'EmployeeID', ''),
				// 	)
				// 	setExecuter(data)
				// } else
				setExecuter(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setExecutorLoading(false)
			})
	}

	const getInvoicePayments = () => {
		setIsLoading(true)
		customFuncsApi
			.get(`XsSql/getInvoiceIncomingPayments?docEntry=${DocEntry}`, {
				headers: {
					Prefer: 'odata.maxpagesize=100',
				},
			})
			.then((res) => {
				setTableInvoicePayments(res.data.value)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const getInformationOfItem = () => {
		setIsLoading(true)
		customFuncsApi
			.get(`XsSql/getInstallments?docEntry=${DocEntry}`, {
				headers: {
					Prefer: 'odata.maxpagesize=50',
				},
			})
			.then((res) => {
				const resData = res.data.value || []
				setTableData(resData)
				setIsLoading(false)
				let a = JSON.parse(JSON.stringify(resData))
				let allSum = 0
				let paySum = 0
				const now = moment().format('YYYYMMDD')
				for (let i = 0; i < a.length; i++) {
					if (!moment(a[i].DueDate, 'YYYYMMDD').isAfter(now, 'day')) {
						allSum = allSum + a[i].PaidToDate
						paySum = paySum + a[i].InsTotal
					}
				}
				setSumPay(allSum)
				setPayingSum(paySum)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const getAllData = async () => {
		await customFuncsApi
			.get(
				`installment?DocEntry=${DocEntry}&InstlmntID=${InstlmntID}&$select=CardCode,CardName,DocEntry,DocNum,U_Telephone,U_Icloud,U_StatusDunner,U_Dunner,U_Score,TotalDebt,U_DeadLine,U_Task,U_IsFreezed`,
			)
			.then((res) => {
				setData(get(res, 'data', {}))
				const U_StatusDunner = get(res, 'data.U_StatusDunner', null)
				setEmployeeID(get(res, 'data.U_Dunner', null))
				setU_Score(get(res, 'data.U_Score', null))
				setTotalDebt(get(res, 'data.TotalDebt', 0))
				setStatusTask(
					U_StatusDunner === 'NotYet' ? 'Bajarilmagan' : 'Bajarilgan',
				)
				setDeadLine(get(res, 'data.U_DeadLine', null))

				setTask(get(res, 'data.U_Task', null))
				setIsFreezed(get(res, 'data.U_IsFreezed', null))
				setFirstIsFreezed(get(res, 'data.U_IsFreezed', null))
			})
			.catch((err) => {
				if (err?.response?.status === 401) {
					navigate('/login', { replace: true })
				}
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const getComments = () => {
		setCommentsLoading(true)
		api
			.get(
				`U_COMMENTS?$filter=U_Invoice eq ${DocEntry}&$orderby=U_CreateTime asc, Code desc`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setComments(resData)
				// const alreadySent = resData.some(
				// 	(v) =>
				// 		v.U_Text === 'Telefon qilindi' &&
				// 		v.U_Dunner === get(getMe, 'EmployeeID', '') &&
				// 		moment(v.U_CreateTime).format('YYYY-MM-DD') ===
				// 			moment().format('YYYY-MM-DD'),
				// )
				// console.log(
				// 	'alreadySent',
				// 	!alreadySent,
				// 	sendCommentInUseEffect,
				// 	DocEntry,
				// )
				// if (!alreadySent && sendCommentInUseEffect && DocEntry) {
				// 	sendComment('Telefon qilindi')
				// }
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setCommentsLoading(false)
			})
	}

	const deleteComments = (id, order) => {
		setIsComment((prevState) => ({ ...prevState, loading: true, order }))
		api
			.delete(`U_COMMENTS(${id})`)
			.then((res) => getComments())
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally((res) => {
				setIsComment((prevState) => ({
					...prevState,
					loading: false,
					order: -1,
				}))
			})
	}

	const sendComment = (comment) => {
		setComment('')
		const date = moment().tz('Etc/GMT-5').format('YYYY-MM-DDTHH:mm:ssZ')

		const body = {
			U_Dunner: get(getMe, 'EmployeeID', ''),
			U_CreateDate: date,
			U_Invoice: DocEntry,
			U_InstlmntID: InstlmntID,
			U_Text: comment,
			U_CreateTime: date,
		}
		api
			.post('U_COMMENTS', body)
			.then((res) => getComments())
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const getUSD = () => {
		setDollarLoading(true)
		api
			.post(`SBOBobService_GetCurrencyRate`, {
				Currency: 'UZS',
				Date: moment(),
			})
			.then((res) => {
				setDollar(JSON.parse(res.data))
			})
			.catch((err) => {
				setDollar('error')
			})
			.finally(() => setDollarLoading(false))
	}

	const createPayment = ({
		DocDate,
		CurrencyRate,
		AmountUsd,
		AmountUzs,
		AmountPayme,
		NumberCard,
		Terminal,
		UsdCard,
		UzsCard,
	}) => {
		setIsLoading(true)
		const payments = []
		if (AmountUsd) {
			payments.push({
				usdSum: AmountUsd,
				account: UsdCard,
				currency: 'USD',
				uzsSum: null,
			})
		}
		if (AmountUzs) {
			payments.push({
				usdSum: AmountUzs / CurrencyRate,
				account: UzsCard,
				currency: 'UZS',
				uzsSum: AmountUzs,
			})
		}
		if (AmountPayme) {
			payments.push({
				usdSum: AmountPayme / CurrencyRate,
				account: NumberCard,
				currency: 'UZS',
				uzsSum: AmountPayme,
			})
		}
		if (Terminal) {
			payments.push({
				usdSum: Terminal / CurrencyRate,
				account: getMe.U_TerminalAccount,
				currency: 'UZS',
				uzsSum: Terminal,
			})
		}
		customFuncsApi
			.post('addIncomingPayments', {
				DocDate,
				DocEntry: DocEntry,
				CardCode: get(data, 'CardCode', null),
				DocRate: CurrencyRate,
				payments: payments,
			})
			.then((err) => {
				// try {
				// 	logsUrl.post('apis', {
				// 		company_name: COMPANY_NAME,
				// 		method: 'post',
				// 		path: `/addIncomingPayments`,
				// 		description: 'bitta undiruvga kirganda tolov qilish',
				// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
				// 		body: JSON.stringify({
				// 			DocDate,
				// 			DocEntry: DocEntry,
				// 			CardCode: get(data, 'CardCode', null),
				// 			DocRate: CurrencyRate,
				// 			payments: payments,
				// 		}),
				// 	})
				// } catch (err) {
				// 	errorRef.current?.open(
				// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
				// 	)
				// }
				paymentRef.current?.close()
				successModalRef.current?.open('Платеж успешно произведен!')
				getInformationOfItem()
			})
			.catch((err) => {
				paymentRef.current?.close()
				errorRef.current?.open(JSON.stringify(err.response.data))
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	const cancel = () => {
		navigate(-1)
	}

	const allSaves = () => {
		setIsCommitLoading(true)
		api
			.patch(`Invoices(${get(data, 'DocEntry', 0)})`, {
				U_Dunner: employeeID,
				U_Score: u_Score,
				U_IsFreezed: isFreezed,
				...(isTask && {
					U_StatusDunner: statusTask === 'Bajarilgan' ? 'Done' : 'NotYet',
				}),
			})
			.then(() => {
				successRef.current?.open('Заказ успешно сохранен')
				setIsCommitLoading(false)
			})
			.catch((err) => {
				setIsCommitLoading(false)
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const allSavesWithEmployee = (employee) => {
		setIsCommitLoading(true)

		api
			.patch(`Invoices(${get(data, 'DocEntry', 0)})`, {
				U_Dunner: employeeID,
				U_Score: u_Score,
				U_IsFreezed: isFreezed,
				U_Undrkim: employee,
				U_DateOdConfis: moment().format('YYYY-MM-DD HH:mm:ss'),

				...(isTask && {
					U_StatusDunner: statusTask === 'Bajarilgan' ? 'Done' : 'NotYet',
				}),
			})
			.then(() => {
				successRef.current?.open('Заказ успешно сохранен')
				setIsCommitLoading(false)
			})
			.catch((err) => {
				setIsCommitLoading(false)
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const columns = [
		{
			title: 'Товар',
			dataIndex: 'ItemDescription',
			key: 'ItemDescription',
			width: 300,
		},
		{
			title: 'Cерийный номер',
			dataIndex: 'serialNumbersText',
			key: 'serialNumbersText',
			render: (val, record, index) => (
				<span>
					{console.log('record', record)}
					{record?.SerialNumbers?.map((v) => v.InternalSerialNumber).join(', ')}
				</span>
			),

			width: 200,
		},
		{
			title: 'Цвет',
			dataIndex: 'color',
			key: 'color',
			width: 150,
			render: (val, record, index) => (
				<span>
					{itemsData?.find((v) => v.ItemCode === record.ItemCode)?.U_Color ||
						'-'}
				</span>
			),
		},
		{
			title: 'Состояние',
			dataIndex: 'condition',
			key: 'condition',
			width: 150,
			render: (val, record, index) => (
				<span>
					{itemsData?.find((v) => v.ItemCode === record.ItemCode)
						?.U_Condition || '-'}
				</span>
			),
		},
	]

	return (
		<Layout>
			<ViewRecoveryItemStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<>
						<div className="flex gap-5">
							<div>
								<div className="mt-5">
									<div className="flex items-end gap-5 flex-wrap">
										<div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Код
											</p>
											<Input
												type="text"
												className={'w-[100px] h-8'}
												style={{ color: 'black' }}
												value={get(data, 'DocNum', 'Kod')}
												disabled={true}
											/>
										</div>
										<div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												ФИО
											</p>
											<Input
												type="text"
												className={'min-w-[250px] h-8'}
												style={{ color: 'black' }}
												value={get(data, 'CardName', 'Покупатель')}
												disabled={true}
											/>
										</div>
										<div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Тел.
											</p>
											<Input
												type="text"
												className={'min-w-[300px] h-8 text-sm'}
												style={{ color: 'black' }}
												value={get(data, 'U_Telephone', 'Tel')}
												disabled={true}
											/>
										</div>

										<div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Icloud
											</p>
											<Input
												type="text"
												className={'min-w-[150px] h-8 '}
												style={{ color: 'black' }}
												value={get(data, 'U_Icloud', '-')}
												disabled={true}
											/>
										</div>
										<Button
											className="!h-8"
											onClick={() => addTask.current.open()}
										>
											Добавить Задачу
										</Button>
										<Button
											className="!h-8"
											onClick={() => sendComment('Telefon qilindi')}
										>
											Звонок сделан
										</Button>
									</div>
									<div className="mt-10 overflow-x-auto">
										<Table
											dataSource={invoiceDocLines}
											columns={columns}
											pagination={false}
											loading={invoiceLoading}
											scroll={{ x: 'max-content' }}
											bordered
											className=" border-[1px] border-gray-500 "
										/>
									</div>
									<div className="mt-5 flex items-start gap-5 flex-wrap w-full">
										{isTask ? (
											<>
												{/* <div className="flex flex-col gap-2">
													<p className={'font-medium text-zinc-600 text-sm '}>
														Задача
													</p>
													<Input
														type="text"
														className={'min-w-[150px] h-8 '}
														style={{ color: 'black' }}
														value={get(data, 'DocEntry', '')}
														disabled={true}
													/>
												</div> */}
												<div className="flex flex-col gap-2">
													<p className={'font-medium text-zinc-600 text-sm '}>
														Дедлайн задачи
													</p>
													<Input
														type="text"
														className={'min-w-[150px] h-8 '}
														style={{ color: 'black' }}
														value={
															deadLine && moment(deadLine).format('DD.MM.YYYY')
														}
														disabled={true}
													/>
												</div>
												<div className="flex flex-col gap-2">
													<p className={'font-medium text-zinc-600 text-sm '}>
														Cтатус задачи
													</p>
													<Select
														type="text"
														className={'w-[200px] h-8 '}
														style={{ color: 'black' }}
														onChange={(val) => setStatusTask(val)}
														value={statusTask}
														disabled={
															!task ||
															!deadLine ||
															(isChangeStatus &&
																firstIsFreezed === 'Bajarilgan')
														}
														options={[
															{
																value: 'Bajarilgan',
																label: 'Bajarilgan',
															},
															{
																value: 'Bajarilmagan',
																label: 'Bajarilmagan',
															},
														]}
													/>
												</div>
												<div className="flex flex-col gap-2">
													<p className={'font-medium text-zinc-600 text-sm '}>
														У кого этот продукт?
													</p>
													<Select
														type="text"
														className={'min-w-[200px] h-8 '}
														style={{ color: 'black' }}
														value={isFreezed}
														onChange={(val) => {
															setIsFreezed(val)
														}}
														disabled={!isChangeFreezed}
														options={[
															{
																value: 'N',
																label: 'Mijozda',
															},
															{
																value: 'Y',
																label: 'Olib qo’yilgan',
															},
														]}
													/>
												</div>
											</>
										) : null}
										{/* <div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Cтатус
											</p>
											<Select
												type="text"
												className={'w-[200px] h-8 '}
												style={{ color: 'black' }}
												value={u_Score}
												onChange={(val) => {
													setU_Score(val)
												}}
												disabled={
													isFreezed === 'Y' &&
													getMe?.Department2?.Name !== 'Boshqaruv'
												}
												options={userFields
													?.find((item) => item.Name === 'Score')
													?.ValidValuesMD.map((value) => ({
														value: value.Value,
														label: value.Description,
													}))}
											/>
										</div> */}
										{/* {isC ? ( */}
										<div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Приёмщик
											</p>
											<Select
												type="text"
												className={'w-[250px] h-8 '}
												style={{ color: 'black' }}
												onChange={(v) => {
													setEmployeeID(v)
												}}
												disabled={!isShowEditCollector}
												loading={executorLoading}
												value={employeeID}
												options={executer.map((v, i) => {
													return {
														value: get(v, 'EmployeesInfo.EmployeeID', 0),
														label: (
															<Tooltip
																title={
																	get(v, 'EmployeesInfo.FirstName', 'Name') +
																	' ' +
																	get(v, 'EmployeesInfo.LastName', 'Surename')
																}
															>
																{get(v, 'EmployeesInfo.FirstName', 'Name') +
																	' ' +
																	get(v, 'EmployeesInfo.LastName', 'Surename')}
															</Tooltip>
														),
													}
												})}
											/>
										</div>
										{/* ) : null} */}
										{/* <div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Свой MIB
											</p>
											<Select
												type="text"
												className={'w-[200px] h-8 '}
												style={{ color: 'black' }}
												disabled
												loading={executorLoading}
												value={undiruvKim}
												options={executer.map((v, i) => {
													return {
														value: get(v, 'EmployeesInfo.EmployeeID', 0),
														label:
															get(v, 'EmployeesInfo.FirstName', 'Name') +
															' ' +
															get(v, 'EmployeesInfo.LastName', 'Surename'),
													}
												})}
											/>
										</div> */}
										<div className="flex flex-col gap-2">
											<p className={'font-medium text-zinc-600 text-sm '}>
												Комментарий
											</p>
											<div className={'flex items-center'}>
												<Input.TextArea
													type="text"
													className={'min-w-[350px] w-full  '}
													style={{ color: 'black' }}
													value={comment}
													rows={2}
													onChange={(v) => setComment(v.target.value)}
												/>
												<button
													className={'sendComment'}
													onClick={() => sendComment(comment)}
													disabled={isEmpty(comment)}
												>
													<AiOutlineSend />
												</button>
											</div>
										</div>
									</div>
									<ViewImage
										path={path}
										setPath={setPath}
										docEntry={DocEntry}
									/>
								</div>
								<div className="flex gap-3 flex-col lg:flex-row justify-end w-full lg:col-span-2 sm:col-span-2 mt-10">
									<div className="flex gap-3">
										<Button
											btnStyle={{ backgroundColor: 'red' }}
											onClick={cancel}
										>
											Назад
										</Button>
									</div>
									{/* Bunda agar birinchi mijozda bolsa va user uni Olib qo'yilganga o'zgartirsa modalka save qilishdan oldin modal ochib undiruvchini tanlatishimiz kerak boladi */}
									{firstIsFreezed === 'N' && isFreezed === 'Y' ? (
										<Button
											btnStyle={{ width: 250 }}
											hoverBtnStyle={{ width: 250 }}
											onClick={() => {
												undiruvchiRef.current.open(freezedPhoneEmployee)
											}}
											isLoading={isCommitLoading}
										>
											Сохранять
										</Button>
									) : (
										<Button
											btnStyle={{ width: 250 }}
											hoverBtnStyle={{ width: 250 }}
											onClick={allSaves}
											isLoading={isCommitLoading}
										>
											Сохранять
										</Button>
									)}
								</div>
								<div className="flex flex-col items-center lg:flex-row gap-5 justify-end mt-5 w-full">
									<div className="flex  items-center p-5 justify-center gap-5 rounded-3xl bg-white drop-shadow-xl ">
										<div className="flex gap-2 flex-col items-center">
											<Tag color="green" className=" text-sm">
												Курс
											</Tag>
											<span className="font-bold text-zinc-900">
												{dollar === 'error'
													? dollar
													: formatNumberWithIntl(dollar) + ' ' + 'UZS'}
											</span>
										</div>
										<div className="flex gap-2 flex-col items-center">
											<Tag color={'red'} className=" text-sm">
												Долг
											</Tag>
											<span className="font-bold text-zinc-900">
												{formatNumberWithIntl(payingSum - sumPay)}
												USD
											</span>
										</div>
										<div className="flex gap-2 flex-col items-center">
											<Tag color={'blue'} className=" text-sm">
												Долг UZS
											</Tag>
											<span className="font-bold text-zinc-900">
												{formatNumberWithIntl((payingSum - sumPay) * dollar)}
												UZS
											</span>
										</div>
										<div className="flex gap-2 flex-col items-center">
											<Tag color="red" className="text-sm">
												Общий долг
											</Tag>
											<span className="font-bold text-zinc-900">
												{formatNumberWithIntl(Number(totalDebt))}
												USD
											</span>
										</div>
										<div></div>
										<div>
											{isShowAddPaymentBtn ? (
												<Button
													btnStyle={{ backgroundColor: '#243AB5' }}
													onClick={() => paymentRef.current?.open()}
													isLoading={isLoading || dollarLoading}
													hoverBtnStyle={{ backgroundColor: '#243AB5' }}
													disabled={isFreezed === 'Y'}
												>
													Оплатить
												</Button>
											) : null}
										</div>
									</div>
								</div>
								<div>
									<div className="flex gap-10 justify-between items-start mb-8 mt-10">
										<div className="overflow-y-auto ">
											<h1 className="font-bold">План Платежа</h1>
											<table className="w-full text-sm text-left rtl:text-right text-black mt-5">
												<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
													<tr>
														<th scope="col" className="px-6 py-4">
															N
														</th>
														<th scope="col" className="px-6 py-4">
															Дата
														</th>
														<th scope="col" className="px-6 py-4">
															Оплата
														</th>
														<th scope="col" className="px-6 py-4">
															Оплачено
														</th>
													</tr>
												</thead>
												<tbody>
													{tableData.map((v, i) => {
														let a = v.DueDate.split('')
														a.splice(4, 0, '-')
														a.splice(7, 0, '-')
														a.join()
														return (
															<tr
																className="bg-white border-b  hover:bg-gray-50 "
																key={i}
															>
																<td className="px-6 py-4 font-medium text-gray-900 ">
																	{i}
																</td>
																<td className="px-6 py-4 whitespace-nowrap">
																	{a}
																</td>
																<td className="px-6 py-4">
																	{Number(v.InsTotal).toFixed(2)}
																</td>
																<td className="px-6 py-4">
																	{roundCurrency(v.PaidToDate)}
																</td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>

										<div className="overflow-y-auto">
											<h1 className={'font-bold mb-3'}>Факт Платежа</h1>
											<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
												<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
													<tr>
														<th scope="col" className="px-6 py-4">
															N
														</th>
														<th scope="col" className="px-6 py-4">
															Дата
														</th>
														<th scope="col" className="px-6 py-4">
															Оплачено
														</th>
														<th scope="col" className="px-6 py-4">
															Курс
														</th>
														<th scope="col" className="px-6 py-4">
															Имя счета
														</th>
														{/* <th scope="col" className="px-6 py-4">
												Комментарий
											</th> */}
													</tr>
												</thead>

												<tbody>
													{tableInvoicePayments.length > 0 ? (
														tableInvoicePayments.map((v, i) => {
															const totalInUZS =
																Number(v.CashSum).toFixed(2) * Number(v.DocRate)
															return (
																<tr
																	className="bg-white border-b  hover:bg-gray-50 "
																	key={i}
																>
																	<td className="px-8 py-6 font-medium text-gray-900 ">
																		{' '}
																		{Number(v.U_CashFlow) === 4 ||
																		Number(v.U_CashFlow) === 5
																			? v['U_CashFlow.Descr']
																			: v?.visualInstNum}
																	</td>

																	<td className="px-6 py-4 whitespace-nowrap">
																		{moment(v.DocDate).format('DD-MM-YYYY')}
																	</td>
																	<td className="px-6 py-4">
																		{new Intl.NumberFormat('fr-FR', {
																			minimumFractionDigits: 2,
																			maximumFractionDigits: 2,
																		})
																			.format(Number(v.CashSum))
																			.replace(',', '.')}{' '}
																	</td>
																	<td className="px-6 py-4">
																		{new Intl.NumberFormat('fr-FR', {
																			minimumFractionDigits: 2,
																			maximumFractionDigits: 2,
																		})
																			.format(Number(v.DocRate))
																			.replace(',', '.')}{' '}
																	</td>

																	<td className="px-6 py-4 ">{v.AcctName}</td>
																</tr>
															)
														})
													) : (
														<>
															<tr>
																<td colSpan={7} className="px-6 py-4">
																	Ничего не найдено
																</td>
															</tr>
														</>
													)}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>

							<div className="shadow-md w-full  md:min-w-[300px] md:max-w-[350px] border-[1px] border-[#DFE2E8]">
								<div className="p-4 shadow-md">
									Комментарии{' '}
									{commentsLoading.loading && (
										<ClipLoader
											loading={true}
											size={10}
											aria-label="Loading Spinner"
											data-testid="loader"
										/>
									)}
								</div>
								<div
									ref={commentRef}
									className="p-4 h-[85vh] overflow-y-scroll"
								>
									{comments.map((v, i) => {
										return (
											<div className="mb-4">
												<p className={'font-medium text-zinc-400 text-sm mb-1'}>
													{moment(get(v, 'U_CreateTime', '')).format(
														'DD-MM-YYYY HH:mm',
													)}
													{isComment.loading && isComment.order === i && (
														<ClipLoader
															loading={true}
															size={10}
															aria-label="Loading Spinner"
															data-testid="loader"
														/>
													)}
												</p>
												<div className="inputCard2">
													<div className="p-3 pt-5 font-medium rounded-lg rounded-bl-none bg-[#29d2f5] text-white relative">
														{isShowDeleteComment && (
															<button
																className="absolute top-1 right-1 z-10 cursor-pointer"
																onClick={() =>
																	deleteComments(get(v, 'Code', ''), i)
																}
															>
																<CloseIcon className="text-white w-[20px] " />
															</button>
														)}

														{get(v, 'U_Text', '')}
													</div>
												</div>
											</div>
										)
									})}
								</div>
							</div>
						</div>
					</>
				</div>
			</ViewRecoveryItemStyle>
			<>
				<FreezedPhonesSelectEmployeeModal
					getRef={(r) => (undiruvchiRef.current = r)}
					onConfirm={(employee) => allSavesWithEmployee(employee)}
					onClose={() => undiruvchiRef.current?.close()}
					loading={isCommitLoading}
				/>
				{dollarLoading ? null : (
					<PaymentModal
						getRef={(r) => (paymentRef.current = r)}
						onConfirm={(form) => createPayment(form)}
						onClose={() => paymentRef.current?.close()}
						loading={isLoading}
						currencyRate={dollar}
						debt={+totalDebt}
					/>
				)}
				<ErrorModal getRef={(r) => (errorRef.current = r)} />
				<SuccessModal
					getRef={(r) => {
						successRef.current = r
					}}
					onConfirm={() => {
						successRef.current?.close()
						navigate(-1)
					}}
				/>
				<SuccessModal
					getRef={(r) => (successModalRef.current = r)}
					onConfirm={() => successModalRef.current?.close()}
				/>
				<AddTask
					getRef={(r) => {
						addTask.current = r
					}}
					onClose={() => {
						addTask.current?.close()
					}}
					executer={executer}
				/>
			</>
		</Layout>
	)
}

export default ViewRecoveryItem
